import { Base } from "./../../framework/base";
import { EnumHelper, WhistleBlowSeverity, WhistleBlowState, WhistleBlowArchiveState } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IWhistleBlowListItem {
    id: string;
    unitCode: string;
    code: string;
    date: number;
    title: string;
    state: WhistleBlowState;
    archiveState: WhistleBlowArchiveState;
    severity: WhistleBlowSeverity;
    anonymous: boolean;
    categoryCode: string;
    createDate: number;
    resolvedDate: number;
    toBeReceivedDate: number;
    toBeReceivedDateUrgency: number;
    toBeRespondedDate: number;
    toBeRespondedDateUrgency: number;
    unreadMessageCount: number;
    handlers: IModifyUser[];

    stateStr: string;
    severityStr: string;
}

export class WhistleBlowListItem implements IWhistleBlowListItem {
    id: string;
    unitCode: string;
    code: string;
    date: number;
    title: string;
    state: WhistleBlowState;
    archiveState: WhistleBlowArchiveState;
    severity: WhistleBlowSeverity;
    anonymous: boolean;
    categoryCode: string;
    createDate: number;
    resolvedDate: number;
    toBeReceivedDate: number;
    toBeReceivedDateUrgency: number;
    toBeRespondedDate: number;
    toBeRespondedDateUrgency: number;
    unreadMessageCount: number;
    handlers: ModifyUser[];

    stateStr: string;
    severityStr: string;

    constructor();
    constructor(obj: IWhistleBlowListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.unitCode = obj && obj.unitCode || "";
        this.code = obj && obj.code || "";
        this.date = obj && obj.date || 0;
        this.title = obj && obj.title || "";
        this.state = obj && obj.state || WhistleBlowState.New;
        this.archiveState = obj && obj.archiveState || WhistleBlowArchiveState.NotArchived;
        this.severity = obj && obj.severity || WhistleBlowSeverity.Unspecified;
        this.anonymous = obj && obj.anonymous || false;
        this.categoryCode = obj && obj.categoryCode || "";
        this.createDate = obj && obj.createDate || 0;
        this.resolvedDate = obj && obj.resolvedDate || 0;
        this.toBeReceivedDate = obj && obj.toBeReceivedDate || 0;
        this.toBeReceivedDateUrgency = obj && obj.toBeReceivedDateUrgency || 0;
        this.toBeRespondedDate = obj && obj.toBeRespondedDate || 0;
        this.toBeRespondedDateUrgency = obj && obj.toBeRespondedDateUrgency || 0;
        this.unreadMessageCount = obj && obj.unreadMessageCount || 0;
        this.handlers = ModifyUser.sortModifyUsers(Base.getTypedArray(obj ? obj.handlers : null, ModifyUser));

        this.stateStr = EnumHelper.WhistleBlowStateToStr(this.state);
        if (!this.categoryCode) {
            this.categoryCode = "-";
        }
        if (this.severity === WhistleBlowSeverity.Unspecified) {
            this.severityStr = "-";
        } else {
            this.severityStr = EnumHelper.WhistleBlowSeverityToStr(this.severity);
        }
    }

    static sortWhistleBlowListItems(items: IWhistleBlowListItem[], column: string, asc: boolean): IWhistleBlowListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "code") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        } else if (column === "date") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.date, b.date)); });
        } else if (column === "severity") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.severity, b.severity)); });
        } else if (column === "anonymous") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.boolCompare(a.anonymous, b.anonymous)); });
        } else if (column === "category") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.categoryCode, b.categoryCode)); });
        } else if (column === "toBeReceivedDate") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.toBeReceivedDate, b.toBeReceivedDate)); });
        } else if (column === "toBeResponsedDate") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.toBeRespondedDate, b.toBeRespondedDate)); });
        } else if (column === "unreadMessageCount") {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.unreadMessageCount, b.unreadMessageCount)); });
        } else {
            return items.sort((a: IWhistleBlowListItem, b: IWhistleBlowListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.state, b.state)); });
        }
    }
}